var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('public-w-dept-rtx-select',{attrs:{"type":"staffs","multiple":"","value":_vm.editValue},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }